const params = new URLSearchParams(window.location.search);
const gclid = params.get('gclid');
const wbraid = params.get('wbraid');
const gbraid = params.get('gbraid');
const gclidData = gclid || wbraid || gbraid;
const fbclid = params.get('fbclid');

if (gclidData) {
  localStorage.setItem('gclid', gclidData);
}

if (fbclid) {
  localStorage.setItem('fbclid', fbclid);
}
